import { render, staticRenderFns } from "./ColumnEditComponent.vue?vue&type=template&id=47cff17e&scoped=true&"
import script from "./ColumnEditComponent.vue?vue&type=script&lang=js&"
export * from "./ColumnEditComponent.vue?vue&type=script&lang=js&"
import style0 from "./ColumnEditComponent.vue?vue&type=style&index=0&id=47cff17e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cff17e",
  null
  
)

export default component.exports